<script setup>
import { formatNumber, formatPrice } from '@js/utils/formatter';

const {
    price1,
    price1Suffix = undefined,
    price2 = undefined,
    price2Suffix = undefined,
    price3 = undefined,
    price3Suffix = undefined,
    withDecimals = true,
    color,
    pillValue = undefined,
    pillType = undefined,
} = defineProps({
    price1: {
        type: Number,
        required: true,
    },
    price1Suffix: {
        type: String,
        required: false,
    },
    price2: {
        type: Number,
        required: false,
    },
    price2Suffix: {
        type: String,
        required: false,
    },
    price3: {
        type: Number,
        required: false,
    },
    price3Suffix: {
        type: String,
        required: false,
    },
    withDecimals: {
        type: Boolean,
        required: false,
    },
    color: {
        type: String,
        required: false,
    },
    pillValue: {
        type: [String, Number],
        required: false,
    },
    pillType: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex h-full flex-col items-start justify-center p-4"
        :class="{
            'bg-green-200 text-green-600': color === 'green',
            'bg-orange-200 text-orange-600': color === 'orange',
            'bg-red-200 text-red-600': color === 'red',
        }"
    >
        <div class="text-lg font-bold whitespace-nowrap">
            {{ formatPrice(price1, withDecimals) }}
            <template v-if="price1Suffix">{{ price1Suffix }}</template>
        </div>

        <div
            v-if="price2 !== undefined && price2 !== null"
            class="whitespace-nowrap"
        >
            {{ formatPrice(price2, withDecimals) }}
            <template v-if="price2Suffix">{{ price2Suffix }}</template>
        </div>

        <div
            v-if="price3 !== undefined && price3 !== null"
            class="whitespace-nowrap"
        >
            {{ formatPrice(price3, withDecimals) }}
            <template v-if="price3Suffix">{{ price3Suffix }}</template>
        </div>

        <div
            v-if="pillValue"
            class="mt-2 inline-flex items-center gap-1 rounded px-2 text-sm font-bold whitespace-nowrap"
            :class="{
                'bg-indigo-600 text-white':
                    pillType === 'primary' || pillType === undefined,
                'bg-gray-200 text-indigo-600': pillType === 'secondary',
                'bg-green-500 text-white': pillType === 'success',
                'bg-yellow-500 text-white': pillType === 'warning',
                'bg-red-500 text-white': pillType === 'danger',
            }"
        >
            <template v-if="typeof pillValue === 'number'">
                {{ formatNumber(pillValue) }}
            </template>

            <template v-else>
                {{ pillValue }}
            </template>
        </div>
    </div>
</template>
